import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import API_BASE_URL from "../../src/config";
import { ClipLoader } from "react-spinners";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useRef } from "react";
import InvoicePDF from "./InvoicePDF";

const BookingDetails = () => {
  const invoiceRef = useRef();
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { bookingId } = useParams();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const token = storedUser.accessToken || localStorage.getItem("accessToken");

    if (!bookingId) {
      console.warn("Booking ID missing.");
      setLoading(false);
      return;
    }

    // No login required — this endpoint looks a booking up by its code
    // (or id) with no auth check, exactly so a guest who booked without an
    // account can still open the link from their confirmation email. Only
    // attach the token when one exists, so a logged-in user's own session
    // still comes through as before.
    const fetchBookingDetails = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}bookings/combo-details`,
          { booking_id: bookingId },
          {
            headers: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.success && response.data?.data?.booking) {
          setBookingData(response.data.data.booking);
        } else if (response.data?.data) {
          setBookingData(response.data.data);
        } else {
          console.warn("Invalid response from API");
        }
      } catch (error) {
        console.error("Error fetching booking details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingDetails();
  }, [bookingId]);

  if (loading) {
    return (
      <section className="bookingdlcontainer">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // adjust if needed
            width: "100%",
          }}
        >
          <ClipLoader loading={loading} size={30} />
        </div>
      </section>

    );
  }

  if (!bookingData) {
    return (
      <section className="bookingdlcontainer">
        <div className="container">
          <p>
            We couldn't find a booking matching this link. Double-check the
            booking code, or contact support if you think this is a mistake.
          </p>
        </div>
      </section>
    );
  }

  const isValidText = (value) => {
    if (value === null || value === undefined) return false;

    const str = String(value).trim().toLowerCase();

    return str !== "" && str !== "0" && str !== "na" && str !== "null";
  };

  const { stay, rooms, summary, user, guests, booking_code, status } = bookingData;
  const primaryGuest = guests?.find((g) => g.is_primary_guest) || guests?.[0] || user || {};

  const handleDownloadInvoice = () => {
    if (!invoiceRef.current) return;

    html2canvas(invoiceRef.current, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Invoice_${bookingData.booking_code}.pdf`);
    });
  };
  return (
    <section className="bookingdlcontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="bookingdlouter">
              <div className="row">
                {/* Left Section */}
                <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12 pe-lg-5">
                  <div className="filterouter align-items-center">
                    <div className="breadcrumbinner">
                      <div className="w-100">
                        <ol className="breadcrumb">
                          <li><Link to="/">Home</Link></li>
                          <li>
                            <Link
                              to="/stays"
                              state={{
                                destination_name:
                                  stay?.location?.location_name || stay?.location_name,
                                destination_id:
                                  stay?.location?.id || stay?.location_id || "",
                                adults: "1",
                                kids: ""
                              }}
                            >
                              Homestays in {stay?.location?.location_name || stay?.location_name}
                            </Link>
                          </li>
                          {/* <li>
                            <a href="javascript:void(0);">
                              Homestays in {stay?.location?.location_name}
                            </a>
                          </li> */}

                          <li><Link to={`/property/${stay?.id}`}>{stay?.title}</Link></li>

                          {/* <li>
                            <a href="javascript:void(0);">{stay?.title}</a>
                          </li> */}
                          <li className="active">Review your Booking</li>
                        </ol>
                      </div>
                    </div>
                  </div>

                  <div className="bookingdltheadingouter">
                    <div className="dltheading">
                      {stay?.rating > 0 && (
                        <span className="startp">
                          <i className="fa fa-star"></i>
                          <span>{stay.rating} stars</span>
                        </span>
                      )}
                      {/* Stay Title as Link */}
                      <h2>
                        <a
                          href={`/guestlinkup/property/${stay.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {stay?.title}
                        </a>
                        , {stay?.location?.location_name}
                      </h2>
                      {isValidText(stay?.description) && (
                        <p>{stay.description}</p>
                      )}
                      {/* Booking Status & Code */}
                      <p><strong>Booking Code:</strong> {booking_code}</p>
                      {/* <p><strong>Status:</strong> {status}</p> */}<p>
                        <strong>Status:</strong>{" "}
                        {status === "pending" ? (
                          <span className="text-warning">Pending Payment</span>
                        ) : (
                          <span className="text-success text-capitalize">{status}</span>
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Stay Single Image */}
                  {stay?.images?.length > 0 && (
                    <div className="row gx-0 mb-3 mb-md-5">
                      <div className="col-12 mb-2">
                        <div className="bookingimg">
                          <img
                            src={stay.images[0].url}
                            alt={stay?.title}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <h3>Your Trip</h3>
                  <div className="row gx-3 gx-lg-4">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Dates</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {summary
                              ? `${new Date(summary.check_in).toLocaleDateString("en-GB", { timeZone: "UTC" })} - ${new Date(summary.check_out).toLocaleDateString("en-GB", { timeZone: "UTC" })}`
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Guests</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {`${summary?.guest_count || 0} Guests`}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Room Details */}
                  {/* {room && (
                    <>
                      <h3>Room Details</h3>
                      <p><strong>Room Name:</strong> {room.title}</p>
                      <p><strong>Description:</strong> {room.description}</p>
                      <p>
                        <strong>Price per Night:</strong> ₹{room.price_per_night}{" "}
                      </p>
                      {room.amenities?.length > 0 && (
                        <p>
                          <strong>Amenities:</strong>{" "}
                          {room.amenities.map((a) => a.name).join(", ")}
                        </p>
                      )}

                      {room.images?.length > 0 && (
                        <div className="row gx-2 mb-3">
                          <div className="col-12">
                            <div className="bookingimg">
                              <img
                                src={room.images[0].url}
                                alt={room.title}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )} */}

                  {rooms && rooms.length > 0 && (
                    <>
                      <h3>Room Details</h3>

                      {rooms.map((room, index) => (
                        <div key={room.id || index} className="mb-4 pb-3" style={{ borderBottom: "1px solid #ddd" }}>

                          <p><strong>Room Name:</strong> {room.title}</p>

                          {isValidText(room.description) && (
                            <p><strong>Description:</strong> {room.description}</p>
                          )}

                          <p>
                            <strong>Price per Night:</strong> ₹{room.price_per_night}
                          </p>

                          <p>
                            <strong>Room Count:</strong> {room.room_count}
                          </p>

                          {/* Small Image */}
                          {room.images?.length > 0 && (
                            <div className="mb-2">
                              <img
                                src={room.images[0].url}
                                alt={room.title}
                                style={{
                                  width: "240px",
                                  height: "160px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc"
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </>
                  )}

                  {/* <h3>Ground Rules</h3>
                  <p>
                    We ask every guest to remember a few simple things about what
                    makes a great guest
                  </p>
                  <ul>
                    <li>Check-in: 12 PM</li>
                    <li>Check-out: 12 PM</li>
                    <li>Primary Guest should be at least 18 years of age.</li>
                  </ul> */}

                  <h3>Guest Details</h3>
                  <div className="row gx-3 gx-lg-4">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>First Name</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {primaryGuest.first_name || user?.firstname || ""}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Last Name</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {primaryGuest.last_name || user?.lastname || ""}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email Address</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {primaryGuest.email || user?.email || ""}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Mobile Number</label>
                        <div className="formgroupinner">
                          <p className="form-control-plaintext mb-0">
                            {primaryGuest.phone || user?.phone || ""}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Primary Guest Address */}
                    {primaryGuest.address && (
                      <div className="col-12">
                        <div className="form-group">
                          <label>Address</label>
                          <div className="formgroupinner">
                            <p className="form-control-plaintext mb-0">{primaryGuest.address}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {guests?.length > 1 && (
                    <>
                      <h4 className="mt-4">Additional Guests</h4>
                      <ul>
                        {guests
                          .filter((g) => !g.is_primary_guest)
                          .map((g) => (
                            <li key={g.id}>
                              {g.title} {g.first_name} {g.last_name}{" "}
                              {g.children_age ? `(Child: ${g.children_age} yrs)` : ""}
                            </li>
                          ))}
                      </ul>
                    </>
                  )}
                </div>

                {/* Right Section */}
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
                  <div className="pricertbx">
                    <h3>Price Breakup</h3>

                    {/* Room x Nights Breakdown */}
                    {(() => {
                      const nights = summary?.nights || 1;
                      const roomCount = summary?.room_count || 1;
                      const basePrice = parseFloat(summary?.base_price || 0);
                      const totalRoomPriceWithoutTax = basePrice;

                      return (
                        <div className="d-flex gx-0 justify-content-between priceborder pb-2 pt-2">
                          <span>
                            <p>
                              <strong>Room {roomCount}:</strong>{" "}
                              <span className="bestprice">
                                ₹{(basePrice / nights).toFixed(2)} per night × {nights} night{nights > 1 ? "s" : ""} =
                              </span>
                            </p>
                          </span>

                          <span className="p-0 prtvalue text-end">
                            ₹{totalRoomPriceWithoutTax.toFixed(2)}
                          </span>
                        </div>
                      );
                    })()}

                    {/* GST */}
                    <div className="d-flex gx-0 justify-content-between priceborder pb-2 pt-2">
                      <p className="mb-0">Total GST</p>
                      <span className="p-0 prtvalue text-end">₹{parseFloat(summary?.room_gst_amount || 0).toFixed(2)}</span>
                    </div>

                    {/* GST Split (CGST / SGST) */}
                    <div className="priceborder pb-2 pt-2 ps-3">
                      <div className="d-flex justify-content-between">
                        <p className="mb-1">CGST</p>
                        <span className="prtvalue">₹{(parseFloat(summary?.room_gst_amount || 0) / 2).toFixed(2)}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="mb-1">SGST</p>
                        <span className="prtvalue">₹{(parseFloat(summary?.room_gst_amount || 0) / 2).toFixed(2)}</span>
                      </div>
                    </div>

                    {/* Commission (if any) */}
                    {parseFloat(summary?.commission_amount || 0) > 0 && (
                      <>
                        <div className="d-flex gx-0 justify-content-between priceborder pb-2 pt-2">
                          <p className="mb-0">Platform Service Fee</p>
                          <span className="p-0 prtvalue text-end">
                            ₹{parseFloat(summary?.commission_amount).toFixed(2)}
                          </span>
                        </div>

                        {/* Commission GST Split */}
                        <div className="priceborder pb-2 pt-2 ps-3">
                          <div className="d-flex justify-content-between">
                            <p className="mb-1">CGST on Platform Fee</p>
                            <span className="prtvalue">₹{(parseFloat(summary?.commission_gst_amount || 0) / 2).toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="mb-1">SGST on Platform Fee</p>
                            <span className="prtvalue">₹{(parseFloat(summary?.commission_gst_amount || 0) / 2).toFixed(2)}</span>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Total Payable */}
                    <div className="priceborder pb-2 pt-2 d-flex justify-content-between total">
                      <p className="mb-0">
                        {/* <strong>Total Paid</strong> */}
                        <strong>
                          {status === "pending" ? "Amount to be Paid" : "Total Paid"}
                        </strong>
                      </p>
                      <span className="p-0 prtvalue text-end">
                        <strong>₹{parseFloat(summary?.total_price || 0).toFixed(2)}</strong>
                      </span>
                    </div>

                    {/* <div style={{ marginTop: 20 }}>
                      <button
                        className="theme-btn"
                        onClick={handleDownloadInvoice}
                      >
                        Download Invoice
                      </button>
                    </div> */}
                    {status !== "pending" && (
                      <div style={{ marginTop: 20 }}>
                        <button
                          className="theme-btn"
                          onClick={handleDownloadInvoice}
                        >
                          Download Invoice
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        {bookingData && <InvoicePDF ref={invoiceRef} bookingData={bookingData} />}
      </div>

    </section>
  );
};




export default BookingDetails;
